export default "__VITE_ASSET__4be9d1fd__"